import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll both window and any overflow-auto containers (e.g. AuthenticatedLayout main)
    window.scrollTo(0, 0);
    document.querySelector("main.overflow-auto")?.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
